<template>
  <!-- Clé d'accès -->
  <div class="group">
    <CardComponent :icon="PhFingerprint" title="Clé d'accès">
      <template #buttons>
        <ButtonElement
          v-if="!cle.is_current"
          color="danger"
          bordered
          :icon="PhTrash"
          size="small"
          :disabled="!cacheStore.online"
          @click="confirmDeleteCle(cle.id)"
          >Supprimer la clé d'accès</ButtonElement
        >
      </template>
      <CardInfoComponent title="Date de création">
        <PhSignIn class="card__info_icon" />
        <span>{{ frenchDate(cle.date_creation) }} {{ frenchTime(cle.date_creation) }}</span>
      </CardInfoComponent>
      <CardInfoComponent title="Gestionnaire">
        <img :src="aaguidMap[cle.aaguid]?.icon_light" alt="Icône" class="card__info_icon" />
        <span>{{ aaguidMap[cle.aaguid]?.name }}</span>
      </CardInfoComponent>
    </CardComponent>

    <!-- Liste des sessions -->
    <div class="cards" v-if="sessions.length">
      <SessionComponent
        v-for="session in sessions"
        :key="session.id"
        :session
        @delete="deleteSession"
      />
    </div>
    <div v-else class="cards">
      <div class="card">
        <p class="paragraph">Aucune session n'utilise cette clé d'accès.</p>
      </div>
    </div>
  </div>
  <ConfirmElement ref="confirmRef" @yes="deleteCle" />
</template>

<script setup lang="ts">
import { PhFingerprint, PhSignIn, PhTrash } from '@phosphor-icons/vue'
import type { CleAccesList } from '@/interfaces/CleAcces.ts'
import { type PropType, useTemplateRef } from 'vue'
import frenchDate from '@/mixins/getFrenchDate.ts'
import type { SessionList } from '@/interfaces/Session.ts'
import SessionComponent from '@/components/mon-compte/SessionComponent.vue'
import ButtonElement from '@/components/ButtonElement.vue'
import frenchTime from '@/mixins/getFrenchTime.ts'
import aaguid from '@/assets/json/aaguid.json'
import type AAGUID from '@/interfaces/AAGUID.ts'
import CardComponent from '@/components/card/CardComponent.vue'
import CardInfoComponent from '@/components/card/CardInfoComponent.vue'
import ConfirmElement from '@/components/ConfirmElement.vue'
import { useCacheStore } from '@/stores/cache.ts'

defineProps({
  cle: {
    type: Object as PropType<CleAccesList>,
    required: true,
  },
  sessions: {
    type: Array as PropType<SessionList[]>,
    required: true,
  },
})

const aaguidMap = aaguid as Record<string, AAGUID>

const confirmRef = useTemplateRef<typeof ConfirmElement>('confirmRef')

const emit = defineEmits(['deleteCle', 'deleteSession'])

const cacheStore = useCacheStore()

function confirmDeleteCle(cleId: string) {
  confirmRef.value?.show(
    cleId,
    "Suppression d'une clé d'accès",
    "Êtes-vous sûr de vouloir supprimer cette clé d'accès ?",
  )
}
function deleteCle(cleId: string) {
  emit('deleteCle', cleId)
}
function deleteSession(sessionId: string) {
  emit('deleteSession', sessionId)
}
</script>
